import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCanvasToolbarZoomOut = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 1024 1024",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M213.333333 469.333333m21.333334 0l554.666666 0q21.333333 0 21.333334 21.333334l0 42.666666q0 21.333333-21.333334 21.333334l-554.666666 0q-21.333333 0-21.333334-21.333334l0-42.666666q0-21.333333 21.333334-21.333334Z" })
});
export default SvgCanvasToolbarZoomOut;
